import withTransparentBackground from 'ui/hoc/withTransparentBackground';
import WelcomeWindow from 'features/WelcomeWindow';
import Login from 'features/Login';
import Signup from 'features/Signup2/Modal';
import UserAreaMenu from 'features/UserAreaMenu';
import PinSetting from 'features/PinSetting';
import Deposit from 'features/Deposit';
import DepositAmountForm from 'features/Deposit/AmountForm';
import DepositLimits from 'features/DepositLimits';
import Transactions from 'features/Transactions';
import SelfExclusion from 'features/SelfExclusion';
import ForgotPassword from 'features/ForgotPassword';
import Withdraw from 'features/Withdraw';
import StatusOfAction from 'features/StatusOfAction';
import UserProfile from 'features/UserProfile';
import DatePicker from 'features/DatePicker';
import ProductsShortcuts from 'features/ProductsShortcuts';
import QuickPickAmount from 'features/QuickPickAmount';
import QuickPickReceiptModal from 'features/QuickPickReceipt/QuickPickReceiptModal';
import VideoPlayer from 'features/VideoPlayer';
import OSShortcutInfo from 'features/OSShortcutInfo';
import QRCodeModal from 'features/QRCodeModal';
import Voucher from 'features/Voucher';
import GameStatistic from 'features/GameStatistic';
import Replay from 'features/Replay';
import { MODALS } from 'features/BetBuddy/config';
import BetBuddy from 'features/BetBuddy/Mobile';
import getTexts from 'utils/localization';
import SuccessBetSaving from 'features/MobileBet/SuccessBetSaving';
import MobileBetList from 'features/MobileBet/MobileBetList';
import MobileBetContainer from 'features/MobileBet/MobileBetContainer';
import ShopList from 'features/MobileBet/ShopList';
import EditSubscriptionsPopup from 'features/BetBuddy/Mobile/EditSubscriptionsPopup.tsx';
import LeaveGroupPopup from 'features/BetBuddy/components/LeaveGroupPopup';
import TempUser from 'features/Signup2/TempUser';
import SessionExpired from 'features/Login/SessionExpired';
import LimitExceed from 'features/Deposit/LimitExceed';
import NewsletterModal from 'features/Newsletter/NewsletterModal';
import LoginPrompt from 'features/Login/LoginPrompt';
import BetSlip from 'features/BetSlip/MobileModal';
import UserAlreadyExistPopup from 'features/Signup2/UserExists';
import LiveStreamTooltipOverlayed from 'features/StreamVideo/LiveStreamTooltipOverlayed';
import LeadPopup from 'features/PinSetting/LeadPopup';
import CPRConfirmModal from 'features/Login/CPRConfirmModal';
import PlayerModal from 'features/YouTubeVideo/PlayerModal.tsx';
import Receipt from 'features/Receipt/ReceiptMobile';
import SmartLynReceiptModal from 'features/QuickPickReceipt/SmartLynReceiptModal';
import SpilIdModal from 'features/SpilID/SpilIdModal';
import PhysicalCardPreview from 'features/SpilID/PhysicalCardPreview';
import PhysicalCardForm from 'features/SpilID/PhysicalCardForm';
import RemoveBonusConfirmModal from 'features/Withdraw/RemoveBonusConfirmModal';
import SelfExcludedModal from '../features/SelfExclusion/SelfExcludedModal';
import SpilIDPinCode from '../features/SpilID/SpilIDPinCode';
const t = getTexts();

const ModalsMapConfig = {
    LOGIN: Login,
    SIGNUP: Signup,
    BET_SLIP: BetSlip,
    WELCOME_WINDOW: WelcomeWindow,
    USER_AREA_MENU: UserAreaMenu,
    PIN_SETTING: PinSetting,
    DEPOSIT: Deposit,
    DEPOSIT_MODAL: DepositAmountForm,
    DEPOSIT_LIMITS: DepositLimits,
    TRANSACTIONS: Transactions,
    WITHDRAW: Withdraw,
    SELF_EXCLUSION: SelfExclusion,
    FORGOT_PASSWORD: ForgotPassword,
    STATUS_OF_ACTION: StatusOfAction,
    PROFILE: UserProfile,
    DATE_PICKER: DatePicker,
    PRODUCTS_SHORTCUTS: ProductsShortcuts,
    QUICK_PICK_AMOUNT: QuickPickAmount,
    QUICK_PICK_RECEIPT: QuickPickReceiptModal,
    VIDEO_PLAYER: VideoPlayer,
    OS_SHORTCUT: OSShortcutInfo,
    PIN_SETUP_LEAD: LeadPopup,
    QR_CODE_MODAL: QRCodeModal,
    VOUCHER: Voucher,
    GAME_STATISTIC: GameStatistic,
    REPLAY: Replay,
    // [MODALS.BET_BUDDY_BETSLIP]: BetBuddyBetSlip,
    SAVED_BET_CONTAINER: MobileBetContainer,
    SAVED_BET_LIST: MobileBetList,
    SUCCESS_BET_SAVING: SuccessBetSaving,
    SHOP_LIST: ShopList,
    EDIT_SUBSCRIPTIONS: EditSubscriptionsPopup,
    [MODALS.BET_BUDDY_ENTRY]: BetBuddy,
    LEAVE_GROUP: LeaveGroupPopup,
    TEMP_USER: withTransparentBackground(TempUser),
    SESSION_EXPIRED: withTransparentBackground(SessionExpired),
    DEPOSIT_LIMIT_EXCEED: withTransparentBackground(LimitExceed),
    NEWSLETTER: NewsletterModal,
    LOGIN_PROMPT: withTransparentBackground(LoginPrompt),
    USER_EXISTS: withTransparentBackground(UserAlreadyExistPopup),
    LIVE_STREAM_TOOLTIP_OVERLAY: LiveStreamTooltipOverlayed,
    CPR_CONFIRMATION: CPRConfirmModal,
    YOUTUBE_PLAYER_POPUP: PlayerModal,
    RECEIPT: Receipt,
    SMART_LYN_RECEIPT: SmartLynReceiptModal,
    SPIL_ID: SpilIdModal,
    SPIL_ID_PC_PREVIEW: PhysicalCardPreview,
    SPIL_ID_PC_FORM: PhysicalCardForm,
    SPIL_ID_PIN_CODE: SpilIDPinCode,
    REMOVE_BONUS_CONFIRM: withTransparentBackground(RemoveBonusConfirmModal),
    SELF_EXCLUDED_MODAL: SelfExcludedModal,
};

const ModalLocationSettings = {
    LOGIN: {
        pathname: '/log-ind',
        goBackOnClose: true,
        goBackBlacklist: [{ pathname: '/promo/velkommen' }],
    },
    SIGNUP: {
        pathname: '/opret-konto',
        goBackOnClose: true,
        goBackBlacklist: [{ pathname: '/promo/velkommen' }],
    },
};

const ModalsByURLSearchParams = {
    spilid: {
        modalId: 'SPIL_ID',
        priority: 2,
    },
    'deposit-success': {
        modalId: 'STATUS_OF_ACTION',
        data: {
            success: true,
            title: t.userArea.deposit.success,
        },
    },
    'deposit-error': {
        modalId: 'STATUS_OF_ACTION',
        data: {
            success: false,
            title: t.userArea.deposit.error,
            text:
                t.userArea.deposit.fundErrors[
                    new URL(window.location.href).searchParams.get('reason')
                ],
        },
    },
    'deposit-form': {
        modalId: 'DEPOSIT_MODAL',
        data: {
            success: true,
            title: t.userArea.deposit.success,
            disableCloseButton: true,
        },
    },
};

export { ModalsMapConfig, ModalLocationSettings, ModalsByURLSearchParams };
